import { useStore } from "@/store/StoreContext";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
  const { settings } = useStore();
  const cfg = settings?.whatsapp_cta || {};
  if (cfg.enabled === false) return null;
  const number = cfg.number || settings?.store?.whatsapp;
  if (!number) return null;
  const msg = encodeURIComponent(cfg.message || "Hi TARISHQ!");
  return (
    <a data-testid="whatsapp-floating-cta"
      href={`https://wa.me/${number}?text=${msg}`}
      target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp"
      className="fixed bottom-20 md:bottom-6 right-4 z-40 w-12 h-12 rounded-full bg-[#1A3C34] text-white flex items-center justify-center shadow-lg hover:scale-110 hover:bg-[#25D366] transition-all">
      <MessageCircle size={22} />
    </a>
  );
}
